import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GET_TEAM_SCHEDULING_SETTINGS_QUERY_KEY =
  'GET_TEAM_SCHEDULING_SETTINGS';

export const useGetTeamSchedulingSettings = (teamId: number) => {
  const { getTeamSchedulingSettings } = useServicesContext();

  return useQuery({
    queryKey: [GET_TEAM_SCHEDULING_SETTINGS_QUERY_KEY, teamId],
    queryFn: () => getTeamSchedulingSettings(teamId),
    enabled: !!teamId,
  });
};
